import React, { useEffect, useRef, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import moment from 'moment-timezone';
import { useDispatch } from 'react-redux';
import {liveHandler} from '../store/liveNumSlice';
import {io} from "socket.io-client";
import { getMethod } from '../Apis/apis';
import { FiCheck,FiClock } from 'react-icons/fi';

const ContainerDiv = styled.div`
   padding: 10px;
   position: relative;
`
const TextBlink = keyframes`
    50% {
        opacity: 1;
    }
    57% {
        opacity: 0;
    }
    64% {
        opacity: 1;
    }
    71% {
        opacity: 0;
    }
    78% {
        opacity: 1;
    }
`

const LiveNumber = styled.h1`
   text-align: center;
   user-select: none;
   color: ${props => props.theme.fontColor};
   font-size: 70px;
   font-weight: bolder;
   text-shadow: 0 4.36px 8.896px #353535, 0 -2px 1px #fff;
   margin-bottom: 10px;
`
const LiveNumberAnimation = styled.h1`
   text-align: center;
   user-select: none;
   color: ${props => props.theme.fontColor};
   font-size: 80px;
   font-weight: bolder;
   text-shadow: 0 4.36px 8.896px #353535, 0 -2px 1px #fff;
   margin-bottom: 10px;
   animation: ${TextBlink} 4s linear infinite;
`

const UpdateTime = styled.div`
   margin: 0;
   font-size: 14px;
   color: ${props => props.theme.fontColor};
   font-weight: 600;
   text-align: center;
   margin-bottom: 0;
   user-select: none;
`

const SetValueContainer = styled.div`
   display: flex;
   justify-content: space-between;
   align-items: center;
   background-color: ${props => props.theme.primary};
   border-radius: 10px;
   padding: 10px 20px;
`
const LiveCard = styled.div`
    color: ${props => props.theme.fontColor};
    display: flex;
    flex-direction: column;
    border-radius: 12px;
    user-select: none;
    width: 100px;
    span {
        font-size: 15px;
        font-weight: 500;
    }
    p {
        font-size: 15px;
        margin-top: 0px;
        font-weight: 600;
        margin-bottom: 0;
    }
`
const UpdatedIcon = styled.span`
   margin-right: 5px;
`

const DateTimeDiv = styled.div`
    padding: 10px;
    border-radius: 10px;
    background-color: ${props => props.theme.fontColor};
    color: #FFF;
    p {
        margin-bottom: 0;
        text-transform: uppercase;
        text-align: center;
    }
`

const UpdatedDate = styled.p`
    margin-bottom: 0;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${props => props.theme.primary};
`
let currentDate = moment().tz("Asia/Yangon").format("DD-MM-YYYY");
let updatedDate = moment().tz("Asia/Yangon").format("MMMM DD, YYYY");
let day = moment().tz("Asia/Yangon").format("dddd,");

const Live = () => {
    const [animate10,setAnimate10] = useState(false);
    const [animate12,setAnimate12] = useState(false);
    const [animate14,setAnimate14] = useState(false);
    const [animate16,setAnimate16] = useState(false);
    const [animate18,setAnimate18] = useState(false);
    const [animate20,setAnimate20] = useState(false);
    const [animate22,setAnimate22] = useState(false);

    const [check10,setCheck10] = useState(false);
    const [check12,setCheck12] = useState(false);
    const [check14,setCheck14] = useState(false);
    const [check16,setCheck16] = useState(false);
    const [check18,setCheck18] = useState(false);
    const [check20,setCheck20] = useState(false);
    const [check22,setCheck22] = useState(false);

    const [result,setResult] = useState("--");
    const dispatch = useDispatch();
    const [serverTime,setServerTime] = useState();
    let date = moment().tz("Asia/Yangon").format("YYYY-MM-DD");
    const [resultTime,setResultTime] = useState("??");
    
    useEffect(()=>{
        const socket = io(`${process.env.REACT_APP_HOST}/time`);
        socket.connect();
        socket.on("STime", res => {
            setServerTime(res)
            return () => {
                socket.disconnect();
            };
        });
    },[]);

    useEffect(()=>{
        const socket = io(`${process.env.REACT_APP_HOST}/live`);
        socket.connect();
        socket.on("live", async res => {
                let timeRes = await getMethod(`/number/time`);
                if(timeRes){
                    if(timeRes.con){
                        if(timeRes.data > "08:00:00" && timeRes.data < "09:59:58"){
                            if(res){
                                setResult(res.result);
                                dispatch(liveHandler(res.result));
                            }
                        }
                        
                        if(timeRes.data > "10:05:00" && timeRes.data < "11:59:58"){
                            if(res){
                                setResult(res.result);
                                dispatch(liveHandler(res.result));
                            }
                        }

                        if(timeRes.data > "12:05:00" && timeRes.data < "13:59:58"){
                            if(res){
                                setResult(res.result);
                                dispatch(liveHandler(res.result));
                            }
                        }

                        if(timeRes.data > "14:05:00" && timeRes.data < "15:59:58"){
                            if(res){
                                setResult(res.result);
                                dispatch(liveHandler(res.result));
                            }
                        }

                        if(timeRes.data > "16:05:00" && timeRes.data < "17:59:58"){
                            if(res){
                                setResult(res.result);
                                dispatch(liveHandler(res.result));
                            }
                        };

                        if(timeRes.data > "18:05:00" && timeRes.data < "19:59:58"){
                            if(res){
                                setResult(res.result);
                                dispatch(liveHandler(res.result));
                            }
                        };

                        if(timeRes.data > "20:05:00" && timeRes.data < "21:59:58"){
                            if(res){
                                setResult(res.result);
                                dispatch(liveHandler(res.result));
                            }
                        };
                    };
                };     
        });
        return () => {
            socket.disconnect();
        };
    },[]);

    useEffect(()=>{

        let ten = "08:00:00";
        let endTen = "09:59:58";
        
        let twelve = "10:05:00";
        let endTwelve = "11:59:58";

        let two = "12:05:00";
        let endTwo = "13:59:58";

        let four = "14:05:00";
        let endFour = "15:59:58";

        let six = "16:05:00";
        let endSix = "17:59:58";

        let eight = "18:05:00";
        let endEight = "19:59:58";

        let nightTen = "20:05:00";
        let endNightTen = "21:59:58";
    
        if(serverTime > "09:59:59" && serverTime < "10:04:59"){
            (async()=>{
                let res = await getMethod(`/number/filter?date=${date}`);
                if(res){
                    if(res.data.length > 0){
                        res.data.map(el => {
                            if(el.time === "10:00 AM"){
                                setResult(el.result);
                            }
                        })
                    }
                };
            })();
        };

        if(serverTime > "11:59:59" && serverTime < "12:04:59"){
            (async()=>{
                let res = await getMethod(`/number/filter?date=${date}`);
                if(res){
                    if(res.data.length > 0){
                        res.data.map(el => {
                            if(el.time === "12:00 PM"){
                                setResult(el.result);
                            }
                        })
                    }
                }
                
            })();
        };

        if(serverTime > "13:59:59" && serverTime < "14:04:59"){
            (async()=>{
                let res = await getMethod(`/number/filter?date=${date}`);
                if(res){
                    if(res.data.length > 0){
                        res.data.map(el => {
                            if(el.time === "02:00 PM"){
                                setResult(el.result);
                            }
                        })
                    }
                }
                
            })();
        };

        if(serverTime > "15:59:59" && serverTime < "16:04:59"){
            (async()=>{
                let res = await getMethod(`/number/filter?date=${date}`);
                if(res){
                    if(res.data.length > 0){
                        res.data.map(el => {
                            if(el.time === "04:00 PM"){
                                setResult(el.result);
                            }
                        })
                    }
                }
                
            })();
        };

        if(serverTime > "17:59:59" && serverTime < "18:04:59"){
            (async()=>{
                let res = await getMethod(`/number/filter?date=${date}`);
                if(res){
                    if(res.data.length > 0){
                        res.data.map(el => {
                            if(el.time === "06:00 PM"){
                                setResult(el.result);
                            }
                        })
                    }
                }
                
            })();
        };

        if(serverTime > "19:59:59" && serverTime < "20:04:59"){
            (async()=>{
                let res = await getMethod(`/number/filter?date=${date}`);
                if(res){
                    if(res.data.length > 0){
                        res.data.map(el => {
                            if(el.time === "08:00 PM"){
                                setResult(el.result);
                            }
                        })
                    }
                }
                
            })();
        };

        if(serverTime > "21:59:59" && serverTime < "23:59:59"){
            (async()=>{
                let res = await getMethod(`/number/filter?date=${date}`);
                if(res){
                    if(res.data.length > 0){
                        res.data.map(el => {
                            if(el.time === "10:00 PM"){
                                setResult(el.result);
                            }
                        })
                    }
                }
                
            })();
        };

        if (serverTime > ten && serverTime < endTen){
            setAnimate10(true);
            setCheck10(true);
            setResultTime("10:00 AM");
        }else{
            setAnimate10(false);
            setCheck10(false);
        };

        if (serverTime > twelve && serverTime < endTwelve){
            setAnimate12(true);
            setCheck12(true);
            setResultTime("12:00 PM");
        }else{
            setAnimate12(false);
            setCheck12(false);
        };

        if (serverTime > two && serverTime < endTwo){
            setAnimate14(true);
            setCheck14(true);
            setResultTime("02:00 PM");
        }else{
            setAnimate14(false);
            setCheck14(false);
        };

        if (serverTime > four && serverTime < endFour){
            setAnimate16(true);
            setCheck16(true);
            setResultTime("04:00 PM");
        }else{
            setAnimate16(false);
            setCheck16(false);
        };

        if (serverTime > six && serverTime < endSix){
            setAnimate18(true);
            setCheck18(true);
            setResultTime("06:00 PM");
        }else{
            setAnimate18(false);
            setCheck18(false);
        };

        if (serverTime > eight && serverTime < endEight){
            setAnimate20(true);
            setCheck20(true);
            setResultTime("08:00 PM");
        }else{
            setAnimate20(false);
            setCheck20(false);
        };

        if (serverTime > nightTen && serverTime < endNightTen){
            setAnimate22(true);
            setCheck22(true);
            setResultTime("10:00 PM");
        }else{
            setAnimate22(false);
            setCheck22(false);
        };
    },[serverTime]);

  return (
    <>
        <ContainerDiv>
            <SetValueContainer>
                <div style={{
                    width: '100%'
                }}>
                    {
                        animate10 || animate12 || animate14 || animate16 || animate18 || animate20 || animate22 ? <LiveNumberAnimation>{result}</LiveNumberAnimation> : <LiveNumber>{result}</LiveNumber>
                    }
                </div>
                <div style={{width: '80%'}}>
                    <DateTimeDiv style={{marginBottom: '10px'}}>
                        <p>Date</p>
                        <p>{currentDate}</p>
                    </DateTimeDiv>
                    <DateTimeDiv>
                        <p>time</p>
                        <p>{resultTime}</p>
                    </DateTimeDiv>
                </div>
            </SetValueContainer>
        </ContainerDiv>
        <UpdatedDate>
             <div style={{marginRight: '5px', display: 'flex',alignItems: 'center'}}> 
                {false ? null : 
                    <UpdatedIcon>
                        {
                            (check10 || check12 || check14 || check16 || check18 || check20 || check22)?
                            <FiClock color="#efb721" size="20px" />
                            :
                            <FiCheck color="#efb721" size="20px" />
                        }
                    </UpdatedIcon>
                }
            </div>
            <span style={{fontSize: '14px'}}>{day} {updatedDate} {serverTime ?? "22:00:04"}</span>
        </UpdatedDate>
    </>
  )
}

export default Live
